<template>
    <CModal
      title="Modal title"
      :show.sync="modalUpload"
      :no-close-on-backdrop="true"
      :centered="true"
      size="lg"
    >
      <CForm v-on:submit.prevent="postData">
        <CRow>
          <CCol sm="12 mb-5">
            <div class="text-over-image no-gutters p-6 pt-5 d-flex align-items-center" v-bind:style="{ backgroundImage: `url('${image}')` }">
                <div class="text-center mx-auto px-5">
                    <div class="px-5">
                        <h1 class="font-weight-bold certificate-title">Sertifikatas</h1>
                        <h6 class="font-italic text-line-2">Diberikan kepada</h6>
                        <h3 class="mb-0 text-uppercase">
                            <strong> {{dataSertifikat.nama_lengkap ? dataSertifikat.nama_lengkap : '-'}}</strong>
                        </h3>
                        <h6 class="kap">{{dataSertifikat.namaKap}}</h6>
                        <h6 class="mb-1 text-italic text-line" v-show="tipePeserta == null"> Atas partisipasinya sebagai peserta    </h6>
                        <h6 class="mb-1 text-italic text-line" v-show="tipePeserta == 'peserta'"> {{dataSertifikat.text_line_satu ? dataSertifikat.text_line_satu : 'Atas partisipasinya sebagai peserta'}}</h6>
                        <h6 class="mb-1 text-italic text-line" v-show="tipePeserta == 'instruktur'"> {{dataSertifikat.text_line_tiga ? dataSertifikat.text_line_tiga : 'Atas partisipasinya sebagai instruktur'}}</h6>
                        <h6 class="mb-1 text-italic text-line" v-show="tipePeserta == 'moderator'"> {{dataSertifikat.text_line_lima ? dataSertifikat.text_line_lima : 'Atas partisipasinya sebagai moderator'}}</h6>
                        <h6 class="mb-0 text-uppercase px-4"><strong class="text-pelatihan">{{dataSertifikat.nama_pelatihan ? dataSertifikat.nama_pelatihan : 'Nama Pelatihan'}}</strong></h6>
                        <h6 class="text-italic text-line mb-1" v-show="tipePeserta == null"  >{{dataSertifikat.text_line_dua ? dataSertifikat.text_line_dua : 'yang diselenggarakan dalam rangka Pelatihan Profesional Berkelanjutan (PPL) Terstruktur'}}</h6>
                        <h6 class="text-italic text-line mb-1" v-show="tipePeserta == null"  >{{dataSertifikat.text_line_tujuh ? dataSertifikat.text_line_tujuh : 'Institut Akuntan Publik Indonesia'}}</h6>
                        <h6 class="text-italic text-line mb-1" v-show="tipePeserta == 'peserta'"  >{{dataSertifikat.text_line_dua ? dataSertifikat.text_line_dua : 'yang diselenggarakan dalam rangka Pelatihan Profesional Berkelanjutan (PPL) Terstruktur'}}</h6>
                        <h6 class="text-italic text-line mb-1" v-show="tipePeserta == 'instruktur'"  >{{dataSertifikat.text_line_empat ? dataSertifikat.text_line_empat : 'yang diselenggarakan dalam rangka Pelatihan Profesional Berkelanjutan (PPL) Terstruktur'}}</h6>
                        <h6 class="text-italic text-line mb-1" v-show="tipePeserta == 'moderator'"  >{{dataSertifikat.text_line_enam ? dataSertifikat.text_line_enam : 'yang diselenggarakan dalam rangka Pelatihan Profesional Berkelanjutan (PPL) Terstruktur'}}</h6>
                        <h6 class="text-italic text-line" v-show="tipePeserta == 'peserta'"  >{{dataSertifikat.text_line_tujuh ? dataSertifikat.text_line_tujuh : 'Institut Akuntan Publik Indonesia'}}</h6>
                        <h6 class="text-italic text-line" v-show="tipePeserta == 'instruktur'"  >{{dataSertifikat.text_line_delapan ? dataSertifikat.text_line_delapan : 'Institut Akuntan Publik Indonesia'}}</h6>
                        <h6 class="text-italic text-line" v-show="tipePeserta == 'moderator'"  >{{dataSertifikat.text_line_sembilan ? dataSertifikat.text_line_sembilan : 'Institut Akuntan Publik Indonesia'}}</h6>
                        <h6 class="text-italic text-line text-capitalize" v-if="dataSertifikat.tanggalPelatihan !== null">{{dataSertifikat.tanggalPelatihan}}</h6>
                        <h6 class="text-italic text-line text-capitalize" v-else>{{convertHari(dataSertifikat.hari_mulai)}} - {{convertHari(dataSertifikat.hari_selesai)}}, {{formatDate(dataSertifikat.tanggal_mulai)}} - {{formatDate(dataSertifikat.tanggal_selesai)}}</h6>
                        <div class="row">
                            <div class="col-md-6 pr-0">
                                <h6 class="text-italic text-line text-capitalize text-right">Durasi : </h6>
                            </div>
                            <div class="col-md-6 pl-2">
                                <h6 class="text-italic text-line text-capitalize text-left">{{dataSertifikat.durasi ? dataSertifikat.durasi : '0' }}</h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 pr-0">
                                <h6 class="text-italic text-line text-capitalize text-right">Jumlah Kredit : </h6>
                            </div>
                            <div class="col-md-6 pl-2">
                                <h6 class="text-italic text-line text-capitalize text-left mb-0" v-if="dataSertifikat.skp_terstruktur != 0 && dataSertifikat.skp_terstruktur != 0">
                                    {{dataSertifikat.skp_terstruktur ? dataSertifikat.skp_terstruktur+' SKP' : '-' }} <span>{{ dataSertifikat.katalogPelatihan.join(', ') }}</span>
                                </h6>
                                <h6 class="text-italic text-line text-capitalize text-left mb-0" v-if="dataSertifikat.skp_tidak_terstruktur != 0 && dataSertifikat.skp_tidak_terstruktur != 0">
                                    {{dataSertifikat.skp_tidak_terstruktur ? dataSertifikat.skp_tidak_terstruktur+' SKP' : '-' }} <span>{{ dataSertifikat.katalogPelatihan.join(', ') }}</span>
                                </h6>
                                <h6 class="text-italic text-line text-capitalize text-left" v-if="dataSertifikat.skp_assessment != 0 && dataSertifikat.skp_assessment != 0">
                                    {{dataSertifikat.skp_assessment +' SKP'  }} Berbasis Penilaian
                                </h6>
                            </div>
                        </div>
                        
                        <div class="nomor-sertifikat mx-auto py-1">
                            <h6 class="mb-0">Nomor : {{dataSertifikat.no_sertifikat ? dataSertifikat.no_sertifikat : '-'}}</h6>
                        </div>
                        <div class="text-small">Dokumen ini dibuat secara elektronik, <br> untuk validasi silakan kirim email ke divisi.ppl@iapi.or.id</div>
                    </div>
                </div>
            </div>
          </CCol>
            <CCol sm="12">
                <label for class="font-weight-bold">Status Penerimaan</label>
                <br />
                <div class="d-flex align-items-center">
                    <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        class="custom-control-input"
                        name="customRadio"
                        id="aktif"
                        value="1"
                        v-model="formData.status_penerimaan"
                    />
                    <label class="custom-control-label" for="aktif">Ya</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        class="custom-control-input"
                        name="customRadio"
                        id="tidak_aktif"
                        value="0"
                        v-model="formData.status_penerimaan"
                    />
                    <label class="custom-control-label" for="tidak_aktif">Tidak</label>
                    </div>
                </div>
            </CCol>
        </CRow>
      </CForm>
      <template #header>
        <h6 class="modal-title h4 font-weight-bold">{{title}}</h6>
      </template>
      <template #footer>
        <CButton @click="modalUpload = false" color="danger">Tutup</CButton>
        <CButton @click="postData" color="success">Simpan</CButton>
      </template>
    </CModal>
</template>

<script>
import BaseUrl from "@/services/base-url";

export default {
    data() {
        return {  
            lihat_foto : null,
            baseUrl: "",
            // image: './img/background-sertifikat.png'
        }
    },
    props: [
        'modalUpload',
        'formData',
        'title',
        'tipePeserta',
        'image',
        'actionPost',
        'fileName',
        'dataSertifikat'
    ],
    watch: {
        modalUpload: function(val) {
            if(!this.modalUpload) {                
                this.$emit('closeModalUpload', val)
            }            
        },        
    },
    mounted() {
        this.BaseUrl = BaseUrl();
    },

    computed: {

    },
    
    methods: {
        convertHari(hari) {
            var days = {
                "MONDAY":"Senin",
                "TUESDAY":"Selasa",
                "WEDNESDAY":"Rabu",
                "THURSDAY":"Kamis",
                "FRIDAY":"Jum'at",
                "SATURDAY":"Sabtu",
                "SUNDAY":"Minggu",
                "DEFAULT":"",
            };

            return (days[hari] || days['DEFAULT']);
        },
        postData() {
            this.$parent.postData(this.formData);
        },
        fileUpload() {
            this.formData.file = e.target.files[0];
            this.fileName = e.target.files[0].name;
            // comment console console.log(e.target.files);
        },
        lihatFile(item) {
            this.$parent.lihatFile(item);
        },
         chooseFiles: function() {
            document.getElementById('fileUpload').click();
        },

        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [day, month, year].join('/');
      },
    }
}
</script>

<style>
@font-face {
    font-family: certificate;
    src: url('/fonts/Certificate.ttf');
}
.certificate-title {
    font-family: certificate !important;
    font-size: 3rem;
    margin-bottom: 0;
}
.text-over-image {
    height: 33.7rem;
    background-position: center top;
    background-size: 100% auto;
}
.nomor-sertifikat {
    padding: 5px;
    border: 1px solid grey;
    width: max-content;
}
.nomor-sertifikat h6 {
    font-size: .6rem;
    font-weight: bold;
}
.text-line {
    font-size: .7rem;
    font-weight: bold;
    font-style: italic;
    text-transform: capitalize !important;
    word-spacing: 0px;
}
.text-pelatihan {
    word-spacing: -2px;
    letter-spacing: 0px;
    font-size: .8rem;
}
.kap {
    font-size: .7rem;
}
.text-uppercse strong {
    font-weight: 800 !important;
}
.text-small {
    font-size: 8px;
    font-weight: 700;
}
.table {
    font-size: .8rem;
}

</style>